import React from 'react'
import { useTheme } from '@mui/material/styles'
import { Control, UseFormSetValue, UseFormGetValues } from 'react-hook-form'

import { Box } from '@mui/material'

import { FormValues } from '..'
import Logo from './Logo'
import Banner from './Banner'

interface AddressesProps {
  control: Control<FormValues>
  setValue: UseFormSetValue<FormValues>
  getValues: UseFormGetValues<FormValues>
  errors: any
}

const Images = (props: AddressesProps) => {
  const theme = useTheme()

  const { control, errors, setValue, getValues } = props

  return (
    <Box
      sx={{
        my: 1,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 2,
        [theme.breakpoints.down('md')]: {
          gridTemplateColumns: '1fr',
        },
      }}
    >
      <Logo
        errors={errors}
        control={control}
        setValue={setValue}
        getValues={getValues}
      />
      <Banner control={control} setValue={setValue} getValues={getValues} />
    </Box>
  )
}

export default Images
